import React from 'react';

import { AuthRole } from '@coachhubio/auth-role';
import { GetServerSideProps } from 'next';

import { Dashboard } from '../src/screens/Dashboard/Dashboard';
import { SectionIds } from '../src/screens/Dashboard/utils/dashboardSideBar';
import { getAccessToken } from '../src/server/getAccessToken';
import { getUser } from '../src/server/getUser';

export default function Page() {
  return <Dashboard currentSectionIndex={SectionIds.OVERVIEW} />;
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const user = getUser(context);
  const accessToken = getAccessToken(context);

  if (!accessToken || !user?.id || !user?.organizationId) {
    return {
      props: {},
    };
  }

  const isAuthorized = user?.roles?.has(AuthRole.OPERATIONS) || user?.roles?.has(AuthRole.CUSTOMER);
  let error = {};

  if (!isAuthorized) {
    error = {
      type: 'NotFound',
    };
  }

  return {
    props: {
      accessToken,
      error,
    },
  };
};
